import { Translatable } from '../../../../translatable';

export enum EsploroAssetDescriptionType {
    ABSTRACT = 'ABSTRACT',
    METHODS = 'METHODS',
    SERIESINFORMATION = 'SERIESINFORMATION',
    TABLEOFCONTENTS = 'TABLEOFCONTENTS',
    COVERAGE = 'COVERAGE',
    AUDIENCE = 'AUDIENCE',
    EDUCATIONLEVEL = 'EDUCATIONLEVEL',
    INSTRUCTIONALMETHOD = 'INSTRUCTIONALMETHOD',
    MEDIATOR = 'MEDIATOR',
    TECHNICALINFO = 'TECHNICALINFO',
    SPATIAL = 'SPATIAL',
    TEMPORAL = 'TEMPORAL',
    OTHER = 'OTHER',
    ILLUSTRATIONS = 'ILLUSTRATIONS',
    BIBLIOGRAPHIC = 'BIBLIOGRAPHIC',
}

export type EsploroAssetDescriptionsModel = {
    assetDescriptions: {
        [type in EsploroAssetDescriptionType]: EsploroAssetDescriptionModel;
    };
};

export interface EsploroAssetDescriptionModel {
    descriptions: Translatable<string[]>;
    type: string;
}
